var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.222 12.89c0 .37-.13.684-.389.943-.259.26-.574.389-.944.389H3.112c-.371 0-.686-.129-.945-.389a1.285 1.285 0 01-.389-.944V3.112c0-.371.13-.686.389-.945.259-.26.574-.389.945-.389h9.777c.37 0 .685.13.944.389.26.26.389.574.389.945v9.777zM15.09.91a2.997 2.997 0 00-2.2-.91H3.112C2.25 0 1.516.303.91.91A2.997 2.997 0 000 3.112v9.777c0 .851.303 1.583.91 2.194.606.612 1.34.917 2.202.917h9.777c.861 0 1.594-.305 2.201-.917.607-.611.91-1.343.91-2.194V3.112A3 3 0 0015.09.91z",
    fill: "#0042CB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.111H8.89v-3.11a.432.432 0 00-.125-.32.433.433 0 00-.32-.125h-.889a.43.43 0 00-.444.445v3.11H4a.434.434 0 00-.32.125.433.433 0 00-.124.32v.888c0 .13.041.237.124.32.084.083.19.125.32.125h3.11v3.11a.43.43 0 00.445.445h.89a.435.435 0 00.319-.125A.433.433 0 008.89 12V8.89H12c.13 0 .237-.042.32-.125a.433.433 0 00.125-.32v-.889a.433.433 0 00-.125-.32.432.432 0 00-.32-.124",
    fill: "#0042CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon-plus.adf331d6ef16e35d68edc7c15eb0a81f.svg";
export { ForwardRef as ReactComponent };